import * as React from "react"
import { useState } from "react";
import ArrowUpCircle from "react-feather/dist/icons/arrow-up-circle";
import { Tooltip, Button } from "reactstrap";
import ReactGA from 'react-ga';

type Props = {
  id: string,
  gaActionSuffix: string,
  gaLabel: string,
};

function hashCode(str) {
  let hash = 0;
  if (str.length == 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i++) {
    let char = str.charCodeAt(i);
    hash = ((hash<<5)-hash)+char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

const Upvote: React.FunctionComponent<Props> = (props) => {
  // const [randomId] = useState(Math.random().toString(36).substr(2));
  const [upvoted, setUpvoted] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const onClick = () => {
    setUpvoted(!upvoted);
    ReactGA.event({
      category: 'Upvote',
      action: upvoted ? `Unupvote ${props.gaActionSuffix}` : `Upvote ${props.gaActionSuffix}`,
      label: props.gaLabel,
    });
  };
  const id = `upvote-${hashCode(props.id)}`;
  return <>
      <Button id={id} onClick={onClick} color="link" className="p-0"><ArrowUpCircle color={upvoted ? '#0052ea' : '#8c98a4'} /></Button>
      <Tooltip placement="bottom" isOpen={tooltipOpen} target={id} toggle={toggle}>{upvoted ? 'Unupvote' : 'Upvote'}</Tooltip>
    </>
};

export default Upvote;
